const optionSelected = require('./optionSelected');

module.exports = { optionSelected };
